import axios from 'axios';
import { API } from '../../constants';

const createAction = name => ({
    GET_NAVBAR_CATEGORY: `${name}_GET_NAVBAR_CATEGORY`,
    GET_HERO_SLIDER: `${name}_GET_HERO_SLIDER`,
    GET_POPUP_PROMOTION: `${name}_GET_POPUP_PROMOTION`,
    GET_NEW_ARRIVAL: `${name}_GET_NEW_ARRIVAL`,
    SET_HEIGHT_OF_CONTAINER: `${name}_SET_HEIGHT_OF_CONTAINER`,
    SET_MIN_HEIGHT_OF_CONTAINER: `${name}_SET_MIN_HEIGHT_OF_CONTAINER`,
});

export const HOME = createAction('HOME');

export const getHeroSlider = () => async (dispatch, getState) => {
    const { currentLanguage } = getState().language;
    const result = await axios
        .get(`${API.HERO_SLIDER}?key=hero`, {
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': currentLanguage
            }
        })
        .then(res => res.data)
        .catch(error => Promise.reject(error));
        
    dispatch({
        type: HOME.GET_HERO_SLIDER,
        payload: result
    });
};

export const getNewArrival = () => async (dispatch, getState) => {
    const { currentLanguage } = getState().language;
    const result = await axios
        .get(API.NEW_ARRIVALS, {
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': currentLanguage
            }
        })
        .then(res => res.data)
        .catch(error => Promise.reject(error));

    dispatch({
        type: HOME.GET_NEW_ARRIVAL,
        payload: result
    });
};

export const getPopupPromotion = () => async (dispatch, getState) =>{
    const { currentLanguage } = getState().language;

    const result = await axios
    .get(API.POPUP_PROMOTION ,{
        headers :{
            'Content-Type': 'application/json',
            'Accept-Language': currentLanguage
        }
    })
    .then(res => {
            return res.data  
    })
    .catch(error => {
        new Error(error);
        return null;
    });
    dispatch({
        type: HOME.GET_POPUP_PROMOTION,
        payload: result
    });
}
